import {
  GET_STATUSES,
  CREATE_STATUS,
  UPDATE_STATUS,
  DELETE_STATUS,
} from '../../state/actionTypes';

const initialState = {
  statuses: {},
};

export default function statusReducer(state = initialState, action) {
  switch (action.type) {
    case GET_STATUSES:
      return {
        ...state,
        statuses: action.payload,
      };
    case CREATE_STATUS: {
      const {
        payload: {
          type,
          status,
        } = {},
      } = action;
      const oldStatuses = state.statuses[type] || {};
      const newStatuses = { ...oldStatuses };
      newStatuses[status.id] = status;
      return {
        ...state,
        statuses: {
          ...state.statuses,
          [type]: newStatuses,
        },
      };
    }
    case UPDATE_STATUS: {
      const {
        payload: {
          type,
          id,
          status,
        } = {},
      } = action;
      const oldStatuses = state.statuses[type] || {};
      const newStatuses = { ...oldStatuses };
      const typeProperty = type === 'equipment' ? 'equipment' : 'bucketTemplateId';
      newStatuses[id] = { id, status, [typeProperty]: type };
      return {
        ...state,
        statuses: {
          ...state.statuses,
          [type]: newStatuses,
        },
      };
    }
    case DELETE_STATUS: {
      const {
        payload: {
          type,
          id,
        } = {},
      } = action;
      const oldStatuses = state.statuses[type] || {};
      const newStatuses = { ...oldStatuses };
      delete newStatuses[id];
      return {
        ...state,
        statuses: {
          ...state.statuses,
          [type]: newStatuses,
        },
      };
    }
    default:
      return state;
  }
}
